(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mccm-product-content"] && !Shopify.designMode) return;
  try {
    
  function formatApplicationInstructions(root) {
    if (!('Segmenter' in Intl)) return;
    const segmenter = new Intl.Segmenter(document.documentElement.lang || 'lt', { granularity: 'sentence' });
    root.querySelectorAll('.mccm-application__instructions .metafield-rich_text_field').forEach((content) => {
      if (content.dataset.applicationFormatted) return;
      const paragraphs = Array.from(content.children);
      if (!paragraphs.length || paragraphs.some((p) => p.tagName !== 'P' || p.children.length)) return;
      const list = document.createElement('ol');
      paragraphs.forEach((paragraph) => {
        for (const { segment } of segmenter.segment(paragraph.textContent)) {
          if (!segment.trim()) continue;
          const item = document.createElement('li');
          const text = document.createElement('span');
          text.textContent = segment.trim();
          item.append(text);
          list.append(item);
        }
      });
      if (list.children.length) {
        content.replaceChildren(list);
        content.dataset.applicationFormatted = 'true';
      }
    });
  }
  formatApplicationInstructions(document);
  document.addEventListener('shopify:section:load', (event) => formatApplicationInstructions(event.target));

  } catch(e) { console.error(e); }
})();
})();
